import { TRAVEL_INSURANCE_STEPS } from '@app/app/esales/travel/_sections/steps/TRAVEL_INSURANCE_STEPS';
import { InsuredTraveler } from '@app/domain/model/eshop/travel/InsuredTraveler';
import { ensureString } from '@app/lib/util/ensureString';
import { validateCompanyCode } from '@app/lib/company-code/validateCompanyCode';
import { PurchaseTravelInsuranceSteps } from '@app/service/eshop/travel/schemas/PurchaseTravelInsuranceSteps';

interface ValidateStepParams {
    currentStepKey: string;
    formData: FormData;
    insuredPersons: InsuredTraveler[];
    personalCodeFallback?: string;
}

export async function validateStep({
    currentStepKey,
    formData,
    insuredPersons,
    personalCodeFallback = '',
}: ValidateStepParams): Promise<void> {
    const stepSchema =
        currentStepKey === TRAVEL_INSURANCE_STEPS.TRAVELERS_SETUP
            ? PurchaseTravelInsuranceSteps[TRAVEL_INSURANCE_STEPS.TRAVELERS_SETUP]
            : PurchaseTravelInsuranceSteps[TRAVEL_INSURANCE_STEPS.SUMMARY];

    const formDataObject: Record<string, unknown> = {};

    if (currentStepKey === TRAVEL_INSURANCE_STEPS.TRAVELERS_SETUP) {
        formDataObject.personalCode = ensureString(formData.get('personalCode'), '');
        const discountCode = ensureString(formData.get('discountCode'), '');
        if (discountCode) {
            formDataObject.discountCode = discountCode;
        }
        formDataObject.insuredPersons = insuredPersons;
    } else if (currentStepKey === TRAVEL_INSURANCE_STEPS.SUMMARY) {
        formDataObject.acceptToPrivacyPolicy = formData.get('acceptToPrivacyPolicy') === 'true';
        formDataObject.acceptToTravelRules = formData.get('acceptToTravelRules') === 'true';
        formDataObject.acceptToMarketingCnl = formData.get('acceptToMarketingCnl') === 'true';
        formDataObject.acceptToMarketingCl = formData.get('acceptToMarketingCl') === 'true';
    }

    const personalCode = ensureString(formData.get('personalCode'), personalCodeFallback);
    const isCompanyForValidation = validateCompanyCode(personalCode).isValid;

    await stepSchema.validate(formDataObject, {
        abortEarly: false,
        context: { isCompany: isCompanyForValidation },
    });
}
